export const messages = {
  en: {
    adminSeckillOrder: {
      queryCondition: 'Query Condition',
      seckillOrder: 'Seckill Orders',
      orderId: 'Order ID',
      productImage: 'Product Image',
      productName: 'Product Name',
      buyer: 'Buyer',
      quantity: 'Quantity',
      seckillPrice: 'Seckill Price',
      purchaseTime: 'Purchase Time',
      status: 'Status',
      deadline: 'Deadline',
      completed: 'Completed',
      pendingPayment: 'Pending Payment',
      query: 'Query',
      orderIdPlaceholder: 'Please enter order ID',
      prodNamePlaceholder: 'Please enter product name',
      buyerNamePlaceholder: 'Please enter buyer name',
      shop: 'Shop'
    }
  },
  zh: {
    adminSeckillOrder: {
      queryCondition: '查询条件',
      seckillOrder: '秒杀订单',
      orderId: '订单ID',
      productImage: '商品图片',
      productName: '商品名称',
      buyer: '购买者',
      quantity: '购买数量',
      seckillPrice: '秒杀金额',
      purchaseTime: '购买时间',
      status: '状态',
      deadline: '截止时间',
      completed: '完成',
      pendingPayment: '待支付',
      query: '查询',
      orderIdPlaceholder: '请填写订单',
      prodNamePlaceholder: '请填写产品名称',
      buyerNamePlaceholder: '请填写购买者',
      shop: '店铺',
    }
  }
}